import {managedRecordingKey, RECORDINGS_ORIGIN} from '../../../../backend-cloud/shared/recording-links';
import {config} from './config';
import {supabase} from './supabase';
import {proxySupabaseUrl} from './supabase-transport';
import {appRecordingKey, APP_API_ORIGIN} from './app-recordings';

export async function resolveRecordingPlayback(url:string):Promise<string>{
  if(appRecordingKey(url)){
    if(/^[a-f0-9]{64}$/.test(new URL(url).searchParams.get('share')||''))return url;
    const {data}=await supabase.auth.getSession();
    if(!data.session)throw new Error('Sign in to play this recording.');
    const response=await fetch(`${APP_API_ORIGIN}/v1/recordings/playback-url`,{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${data.session.access_token}`},body:JSON.stringify({url})});
    const result=await response.json() as {url?:string;error?:string};
    if(!response.ok||!result.url)throw new Error(result.error||'This recording is unavailable.');
    return result.url;
  }
  if(!managedRecordingKey(url))return config.supabaseUrl&&!config.isDemo ? proxySupabaseUrl(url,config.supabaseUrl,window.location.origin) : url;
  if(!config.recordingsApi)return url;
  if(/^[a-f0-9]{64}$/.test(new URL(url).searchParams.get('share')||'')){
    // Read signatures cover the object key, so old links can use the branded
    // transport without issuing a new capability or changing stored rows.
    const branded = new URL(url);
    branded.host = new URL(RECORDINGS_ORIGIN).host;
    return branded.toString();
  }
  const {data}=await supabase.auth.getSession();
  if(!data.session)throw new Error('Sign in to play this recording.');
  const response=await fetch(`${config.recordingsApi}/v1/recordings/playback-url`,{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${data.session.access_token}`},body:JSON.stringify({url})});
  const result=await response.json() as {url?:string;error?:string};
  if(!response.ok||!result.url)throw new Error(result.error||'This recording is unavailable.');
  return result.url;
}
